import type { PalmLineSectionConfig } from "../config/line-sections"
import { PalmChartMeter } from "./palm-chart-meter"
import { PalmSummary } from "./palm-summary"

interface PalmLineSectionProps {
  config: PalmLineSectionConfig
  /** Personalised palm-line copy. */
  description: string
  /** Personalised summary copy. */
  summaryDescription: string
  percent: number
  onAsk: () => void
}

/** One palm-line block: hero, "Written in the Lines", chart meter, summary. Ported from LineSection. */
export function PalmLineSection({
  config,
  description,
  summaryDescription,
  percent,
  onAsk,
}: PalmLineSectionProps) {
  return (
    <>
      <div className="relative mt-10 flex h-[396px] flex-col">
        <img
          src={config.bgImage}
          alt=""
          className="pointer-events-none absolute inset-0 size-full object-contain object-right"
        />
        <div className="relative z-[1] mx-4 mt-auto">
          <h3 className="whitespace-pre-line font-display text-[40px] font-medium text-purple-light">
            {config.title}
          </h3>
          <p className="mt-3 whitespace-pre-line font-body text-base text-purple-light/70">
            {config.subtitle}
          </p>
        </div>
      </div>

      <div className="px-4">
        <h4 className="mt-8 font-display text-2xl font-medium text-purple-light">
          Written in the Lines
        </h4>
        <p className="mt-4 whitespace-pre-line font-body text-base text-purple-light/70">
          {description}
        </p>
        <div className="my-8 h-px w-full bg-purple-light/10" />
        <PalmChartMeter type={config.chartType} value={percent} />
      </div>

      <PalmSummary
        typeText={config.summaryTypeText}
        title={config.summaryTitle}
        description={summaryDescription}
        bgImage={config.summaryBgImage}
        HandIcon={config.HandIcon}
        sectionName={config.sectionName}
        onAsk={onAsk}
      />
    </>
  )
}
